import React from "react";
import { useTranslation } from "react-i18next";
export default function Status({ status, className = "", isDisabled }) {
    const { t } = useTranslation();
    const statusConfig = {
        completed: {
            text: t("base.completed"),
            bgColor: "bg-[#E9E6E4]",
            textColor: "text-[#A0A0A0]",
        },
        expired: {
            text: t("timeRemaining.expired"),
            bgColor: "bg-[#E9E6E4]",
            textColor: "text-[#A0A0A0]",
        },
        full: {
            text: t("base.full"),
            bgColor: "bg-[#E9E6E4]",
            textColor: "text-[#A0A0A0]",
        },
        review: {
            text: t("base.reviewing"),
            bgColor: "bg-[#E9E6E4]",
            textColor: "text-[#A0A0A0]",
        },
        reviewing: {
            text: t("base.reviewing"),
            bgColor: "bg-[#E9E6E4]",
            textColor: "text-[#A0A0A0]",
        },
        paused: {
            text: t("base.paused"),
            bgColor: "bg-[#EF4056]",
            textColor: "text-white",
        },
        saved: {
            text: t("base.saved"),
            bgColor: "bg-[#08B89D]",
            textColor: "text-white",
        },

        eligible: {
            text: t("base.eligible"),
            bgColor: "bg-[#08B89D]",
            textColor: "text-white",
        },

        unsuccessful: {
            text: t("base.unsuccessful"),
            bgColor: "bg-[#F5E3E6]",
            textColor: "text-[#EF4056]",
        },
        pending: {
            text: t("base.pending"),
            bgColor: "bg-[#E1D2F3]",
            textColor: "text-[#A0A0A0]",
        },
        save: {
            text: t("base.saved"),
            bgColor: "bg-[#E1D2F3]",
            textColor: "text-[#A0A0A0]",
        },
        rejected: {
            text: t("base.rejected"),
            bgColor: "bg-[#F5E3E6]",
            textColor: "text-[#EF4056]",
        },
        ineligible: {
            text: t("base.ineligible"),
            bgColor: "bg-[#E9E6E4]",
            textColor: "text-[#A0A0A0]",
        },
    };

    // const config =
    //     statusConfig[status?.toLowerCase()] ||
    //     statusConfig.completed;

    const normalizedStatus = status?.toLowerCase();
    const baseConfig = statusConfig[normalizedStatus] || statusConfig.completed;

    // Override màu nếu bị disable
    const finalConfig = {
        ...baseConfig,
        ...(isDisabled && {
            text: baseConfig.text,
            bgColor: "bg-[rgba(233,230,228,0.5)]",
            textColor: "text-[#D0D0D0]",
        }),
    };

    return (
        <div
            className={`
         ${finalConfig.bgColor}
        ${finalConfig.textColor}
        flex items-center justify-center 
        px-3 py-1.5 rounded-md 
        text-base font-medium 
        min-w-[83px]
         h-[29px]
        ${className}
      `}
        >
            <p>{finalConfig.text}</p>
        </div>
    );
}
